
import { Typography } from '@mui/material';
import React from 'react';
import { AlignProps } from './helper';
const Align = ({ children, align }: AlignProps): JSX.Element =>
(
    <Typography align={align}>{children}</Typography>
)


type CenterProps = {} & AlignProps
export const Center = ({ children }: CenterProps): JSX.Element =>
(
    <Align align='center'>{children}</Align>
)

type LeftProps = {} & AlignProps
export const Left = ({ children }: LeftProps): JSX.Element =>
(
    <Align align='left'>{children}</Align>
)

type RightProps = {} & AlignProps
export const Right = ({ children }: RightProps): JSX.Element =>
(
    <Align align='right'>{children}</Align>
)

export default Align;
